export const addQty="ADD_QTY";
export const reduceQty="REDUCE_QTY"

export const GET_DATA_REQUEST="get_data_request"
export const GET_DATA_SUCCESS="get_data_success"
export const GET_DATA_FAILURE="get_data_failure"